import { render, staticRenderFns } from "./breadcumb.vue?vue&type=template&id=bf19ac28&"
import script from "./breadcumb.vue?vue&type=script&lang=js&"
export * from "./breadcumb.vue?vue&type=script&lang=js&"
import style0 from "./breadcumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports